'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof String.prototype.padStart === 'function' ? String.prototype.padStart : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/string.prototype.padstart/polyfill.js
// module id = 433
// module chunks = 35783957827783 172322841747965